<template>
    <div class="col-12">
        <h4 class="bg-success p-2">
            Bloco I – Serviço de Proteção e Atendimento Especializado a Famílias
            e Indivíduos - PAEFI
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>A.</th>
                <th>Volume de famílias em acompanhamento pelo PAEFI</th>
                <th>Total</th>
            </tr>
            <tr>
                <td>A.1.</td>
                <td>
                    Total de casos (famílias ou indivíduos) em acompanhamento
                    pelo PAEFI
                </td>
                <td>{{ dados.paefi_total }}</td>
            </tr>
            <tr>
                <td>A.2.</td>
                <td>
                    Novos casos (famílias ou indivíduos) inseridos no
                    acompanhamento do PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.paefi_total_mes }}</td>
            </tr>
            <tr class="bg-success">
                <th>B.</th>
                <th>
                    Perfil dos novos casos inseridos no acompanhamento do PAEFI
                    no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <td>B.1.</td>
                <td>Famílias beneficiárias do {{ $t("Bolsa Família") }}</td>
                <td>{{ dados.total_familia_bolsa_familia_creas }}</td>
            </tr>
            <tr>
                <td>B.2.</td>
                <td>Famílias com membros beneficiários do BPC</td>
                <td>{{ dados.total_familia_bpc_creas }}</td>
            </tr>
            <tr>
                <td>B.3.</td>
                <td>
                    Famílias com crianças ou adolescentes em situação de
                    trabalho infantil
                </td>
                <td>{{ dados.count_situacao_trabalho_infantil }}</td>
            </tr>
            <tr>
                <td>B.4.</td>
                <td>
                    Famílias com crianças ou adolescentes em Serviços de
                    Acolhimento
                </td>
                <td>{{ dados.count_servicos_acolhimento }}</td>
            </tr>
            <tr>
                <td>B.5.</td>
                <td>
                    Famílias cuja situação de violência/violação esteja associada ao uso abusivo de substâncias psicoativas
                </td>
                <td>{{ dados.total_familia_vv_uso_abusivo_subs }}</td>
            </tr>
            <tr>
                <td>B.7.</td>
                <td>
                    Famílias com adolescente em cumprimento de Medidas
                    Socioeducativas em meio aberto
                </td>
                <td>{{ dados.count_medidas_socioeducativas }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Os itens B1 a B5 e B7 buscam
            identificar apenas alguns perfis de famílias. É normal que algumas
            famílias contadas no item A2 não se enquadrem em nenhuma das
            condições acima, enquanto outras podem se enquadrar simultaneamente
            em mais de uma condição. Portanto, a soma de B1 a B5 e B7 não terá,
            necessariamente, o mesmo valor relatado em A2.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th colspan="8">
                    Quantidade e perfil das pessoas vítimas de violência ou
                    violações de direitos que ingressaram no PAEFI, durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                    (apenas indivíduos inseridos no acompanhamento no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência)
                </th>
            </tr>
            <tr>
                <td rowspan="3">
                    B.6. Quantidade de pessoas vitimadas, que ingressaram no
                    PAEFI, durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                    (apenas para os novos casos)
                </td>
                <td>Total</td>
                <td>Sexo</td>
                <td>0 a 12 anos</td>
                <td>13 a 17 anos</td>
                <td>18 a 39 anos</td>
                <td>40 a 59 anos</td>
                <td>60 anos ou mais</td>
            </tr>
            <tr>
                <td rowspan="2">
                    {{ dados.violacao_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_12_masculino }}</td>
                <td>{{ dados.violacao_13_17_masculino }}</td>
                <td>{{ dados.violacao_18_39_masculino }}</td>
                <td>{{ dados.violacao_40_59_masculino }}</td>
                <td>{{ dados.violacao_60_masculino }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_12_feminino }}</td>
                <td>{{ dados.violacao_13_17_feminino }}</td>
                <td>{{ dados.violacao_18_39_feminino }}</td>
                <td>{{ dados.violacao_40_59_feminino }}</td>
                <td>{{ dados.violacao_60_feminino }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> O total informado em B6 não é
            necessariamente igual a A2, uma vez que em um novo caso (família)
            inserido no PAEFI poderá haver mais de uma pessoa vitimada.
        </p>
        <h5 class="bg-success p-2">
            Atenção! Do item "C" ao item "I" devem ser informadas as situações
            de violência ou violações de direitos identificadas entre as pessoas
            que ingressaram no PAEFI no
            {{ periodo == "Mensal" ? "mês" : "ano" }} de referência (novos
            casos). Uma mesma pessoa pode ter sido vítima de múltiplas
            violências/violações.
        </h5>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>C.</th>
                <th>
                    Crianças ou adolescentes em situações de violência ou
                    violações, que ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <td>0 a 6 anos</td>
                <td>7 a 12 anos</td>
                <td>13 a 17 anos</td>
            </tr>
            <tr>
                <td rowspan="2">C.1.</td>
                <td rowspan="2">
                    Crianças ou adolescentes vítimas de violência intrafamiliar(física ou psicológica)
                </td>
                <td rowspan="2">
                    {{ dados.violacao_c1_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_6_masculino_c1 }}</td>
                <td>{{ dados.violacao_7_12_masculino_c1 }}</td>
                <td>{{ dados.violacao_13_17_masculino_c1 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_6_feminino_c1 }}</td>
                <td>{{ dados.violacao_7_12_feminino_c1 }}</td>
                <td>{{ dados.violacao_13_17_feminino_c1 }}</td>
            </tr>
            <tr>
                <td rowspan="2">C.2.</td>
                <td rowspan="2">
                    Crianças ou adolescentes vítimas de abuso sexual
                </td>
                <td rowspan="2">
                    {{ dados.violacao_c2_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_6_masculino_c2 }}</td>
                <td>{{ dados.violacao_7_12_masculino_c2 }}</td>
                <td>{{ dados.violacao_13_17_masculino_c2 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_6_feminino_c2 }}</td>
                <td>{{ dados.violacao_7_12_feminino_c2 }}</td>
                <td>{{ dados.violacao_13_17_feminino_c2 }}</td>
            </tr>
            <tr>
                <td rowspan="2">C.3.</td>
                <td rowspan="2">
                    Crianças ou adolescentes vítimas de exploração sexual
                </td>
                <td rowspan="2">
                    {{ dados.violacao_c3_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_6_masculino_c3 }}</td>
                <td>{{ dados.violacao_7_12_masculino_c3 }}</td>
                <td>{{ dados.violacao_13_17_masculino_c3 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_6_feminino_c3 }}</td>
                <td>{{ dados.violacao_7_12_feminino_c3 }}</td>
                <td>{{ dados.violacao_13_17_feminino_c3 }}</td>
            </tr>
            <tr>
                <td rowspan="2">C.4.</td>
                <td rowspan="2">
                    Crianças ou adolescentes vítimas de negligência ou abandono
                </td>
                <td rowspan="2">
                    {{ dados.violacao_c4_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_6_masculino_c4 }}</td>
                <td>{{ dados.violacao_7_12_masculino_c4 }}</td>
                <td>{{ dados.violacao_13_17_masculino_c4 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_6_feminino_c4 }}</td>
                <td>{{ dados.violacao_7_12_feminino_c4 }}</td>
                <td>{{ dados.violacao_13_17_feminino_c4 }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th colspan="2">
                    Crianças ou adolescentes em situação de Trabalho Infantil,
                    que ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <td>0 a 12 anos</td>
                <td>13 a 15 anos</td>
            </tr>
            <tr>
                <td rowspan="2">C.5.</td>
                <td rowspan="2">
                    Crianças ou adolescentes em situação de trabalho infantil
                    (até 15 anos)
                </td>
                <td rowspan="2">
                    {{ dados.violacao_trabalho_infantil_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_trabalho_infantil_0_12_masculino }}</td>
                <td>{{ dados.violacao_trabalho_infantil_13_15_masculino }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_trabalho_infantil_0_12_feminino }}</td>
                <td>{{ dados.violacao_trabalho_infantil_13_15_feminino }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>D.</th>
                <th>
                    Pessoas Idosas - 60 anos ou mais - em situações de violência ou
                    violações que ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <td>60 anos ou mais</td>
            </tr>
            <tr>
                <td rowspan="2">D.1.</td>
                <td rowspan="2">
                    Pessoas idosas vítimas de violência intrafamiliar (física,
                    psicológica ou sexual)
                </td>
                <td rowspan="2">
                    {{ dados.total_v_idoso_d1 }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_idoso_masculino_d1 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_idoso_feminino_d1 }}</td>
            </tr>
            <tr>
                <td rowspan="2">D.2.</td>
                <td rowspan="2">
                    Pessoas idosas vítimas de negligência ou abandono
                </td>
                <td rowspan="2">
                    {{ dados.total_v_idoso_d2 }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_idoso_masculino_d2 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_idoso_feminino_d2 }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>E.</th>
                <th>
                    Pessoas com deficiência, em situações de violência ou
                    violações, que ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">E.1.</td>
                <td rowspan="2">
                    Pessoas com deficiência vítimas de violência intrafamiliar
                    (física, psicológica ou sexual)
                </td>
                <td rowspan="2">
                    {{ dados.violacao_total_e1 }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_12_deficiencia_masculino_e1 }}</td>
                <td>{{ dados.violacao_13_17_deficiencia_masculino_e1 }}</td>
                <td>{{ dados.violacao_18_59_deficiencia_masculino_e1 }}</td>
                <td>{{ dados.violacao_60_deficiencia_masculino_e1 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_12_deficiencia_feminino_e1 }}</td>
                <td>{{ dados.violacao_13_17_deficiencia_feminino_e1 }}</td>
                <td>{{ dados.violacao_18_59_deficiencia_feminino_e1 }}</td>
                <td>{{ dados.violacao_60_deficiencia_feminino_e1 }}</td>
            </tr>
            <tr>
                <td rowspan="2">E.2.</td>
                <td rowspan="2">
                    Pessoas com deficiência vítimas de negligência ou abandono
                </td>
                <td rowspan="2">
                    {{ dados.violacao_total_e2 }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.violacao_0_12_deficiencia_masculino_e2 }}</td>
                <td>{{ dados.violacao_13_17_deficiencia_masculino_e2 }}</td>
                <td>{{ dados.violacao_18_59_deficiencia_masculino_e2 }}</td>
                <td>{{ dados.violacao_60_deficiencia_masculino_e2 }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.violacao_0_12_deficiencia_feminino_e2 }}</td>
                <td>{{ dados.violacao_13_17_deficiencia_feminino_e2 }}</td>
                <td>{{ dados.violacao_18_59_deficiencia_feminino_e2 }}</td>
                <td>{{ dados.violacao_60_deficiencia_feminino_e2 }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>F.</th>
                <th>
                    Mulheres adultas vítimas de violência intrafamiliar que
                    ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>F.1.</th>
                <th>
                    Mulheres adultas (18 a 59 anos) vítimas de violência
                    intrafamiliar (física, psicológica ou sexual)
                </th>
                <td>{{ dados.mulheres_18_59_violencia }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>G.</th>
                <th>
                    Pessoas vítimas de tráficos de seres humanos que ingressaram
                    no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">G.1.</td>
                <td rowspan="2">
                    Pessoas vítimas de tráficos de seres humanos
                </td>
                <td rowspan="2">
                    {{ dados.total_familia_trafico_pessoa_total }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.total_familia_trafico_pessoa_0_12_m }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_13_17_m }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_18_59_m }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_60_mais_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.total_familia_trafico_pessoa_0_12_f }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_13_17_f }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_18_59_f }}</td>
                <td>{{ dados.total_familia_trafico_pessoa_60_mais_f }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>H.</th>
                <th>
                    Pessoas vítimas de discriminação por orientação sexual que
                    ingressaram no PAEFI durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>H.1.</th>
                <th>Pessoas vítimas de discriminação por orientação sexual</th>
                <th>{{ dados.total_familia_vitima_orientacao_sexual }}</th>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr class="bg-success">
                <th>I.</th>
                <th>
                    Pessoas em situação de rua que ingressaram no PAEFI durante o {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">I.1.</td>
                <td rowspan="2">Pessoas em situação de rua</td>
                <td rowspan="2">{{ dados.situacao_rua_total }}</td>
                <td>Masculino</td>
                <td>{{ dados.situacao_rua_0_12_m }}</td>
                <td>{{ dados.situacao_rua_13_17_m }}</td>
                <td>{{ dados.situacao_rua_18_59_m }}</td>
                <td>{{ dados.situacao_rua_60_mais_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.situacao_rua_0_12_f }}</td>
                <td>{{ dados.situacao_rua_13_17_f }}</td>
                <td>{{ dados.situacao_rua_18_59_f }}</td>
                <td>{{ dados.situacao_rua_60_mais_f }}</td>
            </tr>
        </table>

        <h4 class="bg-success p-2">
            Bloco II – Atendimento realizados no CREAS
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>M.</th>
                <th>
                    Atendimentos realizados no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>

            <tr>
                <td>M.1.</td>
                <td>
                    Total de atendimentos individualizados realizados no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_atendimento_individual }}</td>
            </tr>
            <tr>
                <td>M.2.</td>
                <td>
                    Total de atendimentos em grupo realizados no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_atendimento_grupo }}</td>
            </tr>
            <tr>
                <td>M.3.</td>
                <td>
                    Famílias encaminhadas para o CRAS durante no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_encaminhado_cras }}</td>
            </tr>
            <tr>
                <td>M.4.</td>
                <td>
                    Visitas domiciliares realizadas no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_atendimento_domiciliar }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Nos itens do campo M, deve ser
            computada a quantidade de atendimentos realizados durante o
            {{ periodo == "Mensal" ? "mês" : "ano" }} de referência. Neste caso,
            se uma mesma pessoa tiver sido atendida cinco vezes no
            {{ periodo == "Mensal" ? "mês" : "ano" }} de referência, deve-se
            registrar os cinco atendimentos.
        </p>
        <h4 class="bg-success p-2">
            Bloco III – Serviço de Proteção Social a Adolescente em Cumprimento
            de Medida Socioeducativa (LA/PSC)
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>J.</th>
                <th>
                    Volume de adolescentes em cumprimento de Medidas
                    Socioeducativas
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <td>J.1.</td>
                <td>
                    Total de adolescentes em cumprimento de Medidas
                    Socioeducativas (LA e/ou PSC)
                </td>
                <td>
                    {{ dados.total_ms_la_psc }}
                </td>
            </tr>
            <tr>
                <td>J.2.</td>
                <td>
                    Quantidade de adolescentes em cumprimento de Liberdade
                    Assistida - LA
                </td>
                <td>{{ dados.total_ms_la }}</td>
            </tr>
            <tr>
                <td>J.3.</td>
                <td>
                    Quantidade de adolescentes em cumprimento de Prestação de
                    Serviços à Comunidade - PSC
                </td>
                <td>{{ dados.total_ms_psc }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Eventualmente um mesmo
            adolescente pode estar cumprindo, simultaneamente, as medidas de LA
            e de PSC, portanto pode ocorrer que a soma de J2 e J3 seja maior que
            o valor relatado em J1, entretanto a soma de J2 e J3 nunca pode ser
            menor que J1.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th colspan="2">
                    Quantidade e perfil dos novos adolescentes inseridos no
                    Serviço, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th colspan="2">Sexo</th>
            </tr>
            <tr>
                <td rowspan="2">J.4.</td>
                <td rowspan="2">
                    Total de novos adolescentes em cumprimento de Medidas
                    Socioeducativas (LA e/ou PSC), inseridos em acompanhamento
                    no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">
                    {{ dados.total_msa_psc_la }}
                </td>
                <td>Masculino</td>
                <td>
                    {{ dados.total_msa_psc_la_m }}
                </td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>
                    {{ dados.total_msa_psc_la_f }}
                </td>
            </tr>
            <tr>
                <td rowspan="2">J.5.</td>
                <td rowspan="2">
                    Novos adolescentes em cumprimento de LA, inseridos em
                    acompanhamento no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">
                    {{ dados.total_msa_la }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.total_msa_la_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.total_msa_la_f }}</td>
            </tr>
            <tr>
                <td rowspan="2">J.6.</td>
                <td rowspan="2">
                    Novos adolescentes em cumprimento de PSC, inseridos em
                    acompanhamento no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">
                    {{ dados.total_msa_psc }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.total_msa_psc_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.total_msa_psc_f }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> A soma de J5 e J6 pode ser maior
            que o valor relatado em J4, entretanto a soma de J5 e J6 nunca pode
            ser menor que J4.
        </p>
        <h4 class="bg-success p-2">
            Bloco IV - Serviço Especializado em Abordagem Social
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>K.</th>
                <th>
                    Quantidade e perfil de pessoas abordadas pela equipe do
                    Serviço de Abordagem, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">K.1.</td>
                <td rowspan="2">
                    Pessoas abordadas pelo Serviço de Abordagem Social, durante
                    o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">
                    {{ dados.total_atendimentos_abordagem }}
                </td>
                <td>Masculino</td>
                <td>{{ dados.at_abordagem_0_12_m }}</td>
                <td>{{ dados.at_abordagem_13_17_m }}</td>
                <td>{{ dados.at_abordagem_18_59_m }}</td>
                <td>{{ dados.at_abordagem_60_mais_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.at_abordagem_0_12_f }}</td>
                <td>{{ dados.at_abordagem_13_17_f }}</td>
                <td>{{ dados.at_abordagem_18_59_f }}</td>
                <td>{{ dados.at_abordagem_60_mais_f }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Em K1, cada pessoa deve ser
            contada uma única vez a cada
            {{ periodo == "Mensal" ? "mês" : "ano" }}, mesmo que tenha sido
            abordada várias vezes nesse mesmo
            {{ periodo == "Mensal" ? "mês" : "ano" }}.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th colspan="2">
                    Situações identificadas pelo Serviço Especializado em
                    Abordagem Social, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }}
                    de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <td>K.2.</td>
                <td>
                    Crianças ou adolescentes em situação de trabalho infantil
                    (até 15 anos)
                </td>
                <td>{{ dados.abordagem_trabalho_infantil }}</td>
            </tr>
            <tr>
                <td>K.3.</td>
                <td>
                    Crianças ou adolescentes em situação de exploração sexual
                </td>
                <td>{{ dados.abordagem_exploracao_sexual }}</td>
            </tr>
            <tr>
                <td>K.4.</td>
                <td>
                    Crianças ou adolescentes usuárias de crack ou outras drogas
                </td>
                <td>{{ dados.abordagem_criancas_uso_drogas }}</td>
            </tr>
            <tr>
                <td>K.5.</td>
                <td>
                    Pessoas adultas usuárias de crack ou outras drogas ilícitas
                </td>
                <td>{{ dados.abordagem_adultos_uso_drogas }}</td>
            </tr>
            <tr>
                <td>K.6.</td>
                <td>Migrantes</td>
                <td>{{ dados.abordagem_total_migrates }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Os itens K2 a K6 buscam
            identificar apenas alguns perfis das pessoas abordadas. É normal que
            algumas pessoas contadas no item K1 não se enquadrem em nenhuma das
            condições descritas acima, enquanto outras pessoas podem se
            enquadrar simultaneamente em mais de uma. Portanto, a soma de K2 a
            K6 não terá, necessariamente, o mesmo valor relatado no total de K1.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>L.</th>
                <th>
                    Situações identificadas pelo Serviço Especializado em
                    Abordagem Social, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }}
                    de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <td>L.1.</td>
                <td>
                    Quantidade total de abordagens realizadas (compreendida como
                    o número de pessoas abordadas, multiplicado pelo número de
                    vezes em que foram abordadas durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }})
                </td>
                <td>{{ dados.atendimentos_abordagem_geral }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Quando a abordagem é feita a um
            grupo, cada pessoa do grupo é contada como uma abordagem.
        </p>
        <h4 v-if="footer != false">
            Nome e cargo da pessoa responsável no CREAS pelas informações:
        </h4>
        <div v-if="footer != false" class="row px-3 mt-4">
            <div class="col-8 pl-0 border-bottom">Assinatura:</div>
            <div class="col-4 border-bottom">CPF:</div>
        </div>

        <div class="footer_impressao">
            <div v-if="tecnico">
                <span><strong>Técnico responsável:</strong> {{ tecnico.nome }}</span>
                <span v-if="tecnico.profissao"><strong>Cargo:</strong> {{ tecnico.profissao }}</span>
                <span><strong>Data/Hora da emissão:</strong> {{ dataHoraAtual }}</span>
            </div>
        </div>

    </div>
</template>

<style>

    .footer_impressao {
        display: none;
    }

    /* Se quiser que apareça apenas na impressão */
    @media print {
        .footer_impressao {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            border-top: 1px solid #ccc;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    /* Adiciona o separador " - " automaticamente entre os spans */
    .footer_impressao span:not(:last-child)::after {
        content: " - ";
        margin: 0 5px;
    }

</style>

<script>
export default {
    name: "RMA_CREAS",
    props: ["mes", "ano", "periodo", "unidade", "dados", "header", "footer"],
    data() {
        return {
            unidadeSelected: "",
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            tecnico: null,
            dataHoraAtual: null,
        };
    },

    mounted() {
        this.getTecnico();
        this.definirDataHoraAtual();
    },

    methods: {

        getTecnico() {
            const userId = this.$store.state.user.id;

            axios.get(`/api/dashboard/tecnico/get/user_id/${userId}`).then((response) => {
                this.tecnico = response.data.data;
            })
            .catch((error) => {
                console.error("Erro ao buscar técnico:", error);
            });
        },

        definirDataHoraAtual() {
            const agora = new Date();
            const dataFormatada = agora.toLocaleDateString("pt-BR");
            const horaFormatada = agora.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
            this.dataHoraAtual = `${dataFormatada} ${horaFormatada}`;
        },

    },

};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
